import { Button, Divider } from '@aws-amplify/ui-react';
import icon from 'media/images/svgSprite.svg';

const GoogleSignInButton = ({ title, signInFunc }) => {
  return (
    <div
      className="amplify-flex federated-sign-in-container"
      style={{
        textAlign: 'center',
        flexDirection: 'column',
        padding: '0px 0px 1rem',
      }}
    >
      <Button
        onClick={signInFunc}
        isFullWidth
        style={{
          width: '100%',
          gap: '1rem',
        }}
        className="federated-sign-in-button"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          aria-label="Google icon"
          className="amplify-icon federated-sign-in-icon"
        >
          <use href={`${icon}#icon-google`}></use>
        </svg>
        <span className="amplify-text">{title}</span>
      </Button>
      <Divider data-label="or" orientation="horizontal" size="small" />
    </div>
  );
};

export default GoogleSignInButton;
